module.exports = require("@babel/runtime/helpers/getPrototypeOf");